@let showImg = (imgSnippet || oldImgSrc);
<div
  class="upload-control flex flex-row items-center justify-center clickable relative {{widthHeight}}"
  (click)="emulateInputClick()">
  @if (showImg) {
    <img
      #logo
      class="max-w-full max-h-full"
      [src]="imgSnippet ? imgSnippet.src : oldImgSrc"
      (error)="logo.src=errorImageLink">
    <app-all-icons
      data-qa="delete-avatar-btn"
      class="absolute top-[0.5em] right-[0.5em]"
      [iconNameAndStyling]="'delete.svg; icon-size-2; red-11'"
      (click)="$event.stopPropagation(); deleteClicked()"
    />
  } @else {
    <div class="flex flex-col items-center content-center gap-[1rem]">
      <app-all-icons [iconNameAndStyling]="'upload.svg; icon-size-2; opacity0p5'"/>
      <span class="font-3 text">{{placeholder}}</span>
    </div>
  }
</div>

@if (inputSwitcher) {
  <input #imageInput hidden type="file" accept="image/*" (change)="processFile(imageInput)">
} @else {
  <input #imageInput hidden type="file" accept="image/*" (change)="processFile(imageInput)">
}


